import { z } from 'zod'
import { zLocale } from '../../i18n'
import {
  zAnnotationArea,
  zAnnotationHorizontalLine,
  zAnnotationPoint,
  zAnnotationVerticalLine,
  zBackgroundColor,
  zColor,
  zCrosshairLine,
  zDataset,
  zDimensionLinkage,
  zDimensions,
  zEncoding,
  zLabel,
  zLegend,
  zLinearRegressionLine,
  zLogisticRegressionLine,
  zLowessRegressionLine,
  zMeasures,
  zPointStyle,
  zPolynomialRegressionLine,
  zTheme,
  zTooltip,
  zBrush,
  zXLinearAxis,
  zYLinearAxis,
  zPage,
  zScatterAnimation,
} from '../../properties'

export const zScatter = z.object({
  chartType: z.literal('scatter'),
  dataset: zDataset.nullish(),
  encoding: zEncoding.nullish(),
  dimensions: zDimensions.nullish(),
  measures: zMeasures.nullish(),
  page: zPage.nullish(),

  backgroundColor: zBackgroundColor.nullish(),
  size: z.number().or(z.array(z.number())).nullish(),
  sizeRange: z.number().or(z.array(z.number())).nullish(),
  color: zColor.nullish(),
  label: zLabel.nullish(),
  legend: zLegend.nullish(),
  tooltip: zTooltip.nullish(),
  brush: zBrush.nullish(),
  animation: zScatterAnimation.nullish(),
  xAxis: zXLinearAxis.nullish(),
  yAxis: zYLinearAxis.nullish(),
  crosshairLine: zCrosshairLine.nullish(),
  theme: zTheme.nullish(),
  pointStyle: z.array(zPointStyle).or(zPointStyle).nullish(),
  annotationPoint: z.array(zAnnotationPoint).or(zAnnotationPoint).nullish(),
  annotationVerticalLine: z.array(zAnnotationVerticalLine).or(zAnnotationVerticalLine).nullish(),
  annotationHorizontalLine: z.array(zAnnotationHorizontalLine).or(zAnnotationHorizontalLine).nullish(),
  annotationArea: z.array(zAnnotationArea).or(zAnnotationArea).nullish(),
  linearRegressionLine: z.array(zLinearRegressionLine).or(zLinearRegressionLine).nullish(),
  lowessRegressionLine: z.array(zLowessRegressionLine).or(zLowessRegressionLine).nullish(),
  polynomialRegressionLine: z.array(zPolynomialRegressionLine).or(zPolynomialRegressionLine).nullish(),
  logisticRegressionLine: z.array(zLogisticRegressionLine).or(zLogisticRegressionLine).nullish(),
  dimensionLinkage: zDimensionLinkage.nullish(),
  locale: zLocale.nullish(),
})
